export class ConversionDetails {
  linearMeters?: number = undefined;
  wastePercentage?: number = undefined;
  waste?: number = undefined;
  netWeight?: number = undefined;
  kgPerHour?: number = undefined;
  plannedHours?: number = undefined;
  totalQuantity: number = 0;
  numberOfPieces?: number = undefined;
  pcsPerStroke?: number = undefined;
}